import OneSignal from 'Components/common/components/OneSignal';
import NavBarPrimary from 'Components/layout/headers/NavBarPrimary';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import styled from 'styled-components';
import {
  boxShadow,
  favouriteArticleColor,
  maxMobile,
  maxTablet,
  maxWidth,
  primaryColor,
  maxWidth1300,
  primaryFont,
  retina, secondaryFont, whiteColor, wMedium, primaryHeadingColor,
  greyColor,
} from 'Utils/utilsStyle';
import { Article } from 'Types/ArticleTypes';
import {
  setImageSize, getId, isActive, IsTablet,
} from 'Utils/UtilityFunctions';
import { Col, Popover, Row } from 'antd';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import SocialShareIcons from 'Components/share/SocialShareIcons';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  actions,
} from 'Slice/ArticlesSlice';
import { actions as favouriteArticleActions } from 'Slice/FavoriteArticlesSlice';
import DrawerHeading from 'Components/common/components/DrawerHeading';
import DonutChart from 'Components/common/charts/DonutChart';
import { formatConcepts } from 'Components/common/components/ArticleInfo';
import ArticleDrawerSkeleton from 'Components/common/skeleton/ArticleDrawerSkeleton';
import EntityTile from 'Components/common/components/EntityTile';
import { selectArticle, selectLoading } from 'Selector/ArticleSector';
import FavoriteIcon from 'Components/common/assets/svgIcons/FavoriteIcon';
import HTMLReactParser from 'html-react-parser';
import GlobalButton from 'Components/common/components/GlobalButton';
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { selectData } from 'Selector/BranchSelector';
import _ from 'lodash';
import NoDataFound from 'Components/common/components/NoDataFound';
import { NODATAFOUND } from 'Utils/Constants';
import ShareArticleStrokeIcon from 'Components/common/assets/svgIcons/ShareArticleStrokeIcon';

const StyleWrapper = styled.div`
  .content-area{
    padding-top: 15px;
    padding: 15px 90px 0px 90px;
    @media all and (max-width: ${maxWidth1300}) { 
      padding: 15px 30px 0px 30px;
    }
    @media all and (max-width: ${maxTablet}) {
      padding: 15px 20px 0px 20px;
    }
    @media all and (max-width: ${maxMobile}) {
      padding: 20px;
      flex-direction: column;
    }
    .col-custom {
      max-width: 48%;
      flex: 0 0 48%;
      @media all and (max-width: ${maxMobile}) {
        max-width: 100%;
        flex: 0 0 100%;
      }
      .concepts-margin {
        @media all and (max-width: ${maxMobile}) {
         margin-top: 20px;
        }
      }
    }
  }
  .fancy-box {
    border-radius: 22px;
    background: rgb(255, 255, 255);
    padding: 24px 42px 28px 42px;
    @media all and (max-width: ${maxTablet}) {
      padding: 24px 25px 28px 25px;
    }
    @media all and (max-width: ${maxMobile}) {
      padding: 20px 10px 10px 10px;
    }
    .article-title{
      font-family: ${secondaryFont};
      font-size: 28px;
      line-height: 36px;
      color: ${primaryHeadingColor};
      font-weight: 600;
      letter-spacing: -0.7px;
      max-width: 547px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 27px;
        line-height: 32px;
      }
      @media all and (max-width: ${maxMobile}) {
        font-size: 18px;
        line-height: 20px;
      }
    }
    .article-image{
      width: 100%;
      margin-bottom: 16px;
      margin-top: 16px;
      max-height:440px;
      height: 440px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        max-height:350px;
        height: 350px;
        width: 100%;
      }
      @media all and (max-width: ${maxMobile}) {
        max-height: 200px;
        height: 200px;
      }
      }
      .article-details{ 
        font-family: ${primaryFont};
        font-weight: ${wMedium};
        font-size: 16px;
        line-height: 22px;
        color: #7E7E7E;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 12px;
          line-height: 16px;
          padding-right: 10px;
        }
      }
      .article-metadata{
        margin-top: 8px;
      }
      .article-source{
        font-family: ${primaryFont};
        color:#DB3725;
        font-size: 14px;
        line-height: 26px;
        font-weight:  ${wMedium};
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 10px;
          line-height: 12px;
        }
      }
      .article-timestamp{
        font-family: ${primaryFont};
        color: #7E7E7E;
        font-size: 14px;
        line-height: 26px;
        font-weight:  ${wMedium};
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 10px;
          line-height: 12px;
        }
      }
      .article-company{
        font-family: ${primaryFont};
        color: #1EC252;
        font-size: 14px;
        line-height: 26px;
        font-weight: ${wMedium};
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 10px;
          line-height: 12px;
        }
        .separator {
          margin: 0px;
        }
      }
      .separator {
        border-left: 1.5px solid #7E7E7E;
        padding: 0px 5px;
        margin: 0px 5px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          padding: 0px 3px;
          margin: 0px 3px;
          width:0;
        }
      }
      .tabs-item {
        @media all and (max-width: ${maxWidth}) , ${retina} {
          padding: 5px 8px;
          margin-right: 8px;
          white-space: nowrap;
        }
        svg{
          vertical-align: middle;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            width: 12px;
            height: 12px;
          }
        }
      }
      .entities-margin{
        margin-top: 29px;
        padding-top: 11px;
        padding-bottom:25px;
      }
      .concepts-margin{
        margin-top: 29px;
      }
      .line-width{
        width: 80%;
      }
      .button-section{
        position: relative;
        margin-top: 35px;
        margin-bottom:29px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          margin-top: 20px;
          margin-bottom:15px;
          padding-right: 0px;
        }
        .favorite-icon{
          position: absolute;
          cursor: pointer;
          left: 125px;
          top: 0px;
          svg{
            height: 22px;
            width:22px;
          }
          @media all and (max-width: ${maxWidth}) , ${retina} {
            left: 85px;
            top: 3px;
            width: 38px;
             svg{
                height: 18px;
                width:18px;
            }
          }
        }
        .padded-entities{
          padding-right: 62px;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            padding-right: 30px;
          }
        }
        .ant-popover-inner{
          border-radius: 16px;
          .ant-popover-inner-content{
            padding: 0;
          }
        }
        .entities_Block{
          column-gap: 10px;
          row-gap: 10px;
        }
      }
  }
`;

const Image = styled.div<{ backgroundImage: string }>`
  background-image: url(${(props) => props.backgroundImage});
  height: 100%;
  width: 468px;
  background-position: center;
  background-size: cover;
`;

const ContentWrapper = styled.div`
  min-width: 238px;
  padding: 20px 25px;
  border-radius: 16px;
  box-shadow: ${boxShadow};
  .heading-popover {
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMedium};
    color: ${primaryColor};
  }
  .share-icons-wrapper .teams-share-button:before{
    top: 2px;
    width: 20.5px;
    height: 20.5px;
  }
`;

type LocationStateInterface = {
  isPushNotification: boolean
};

const Articles = function Articles() {
  const [article, setArticle] = useState<Article>();
  const id: number = getId();
  const [showAll, setShowAll] = useState(false);
  const isTab = IsTablet();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state as LocationStateInterface;
  const elementRef = useRef<HTMLDivElement>(null);
  const loading = useSelector(selectLoading);

  const branchData = useSelector(selectData);
  const { data_parsed: dataParsed } = branchData || {};

  useEffect(() => {
    if (id) {
      dispatch(actions.getArticle({
        articleid: id,
        ...(locationState?.isPushNotification
          && { isPushNotification: locationState?.isPushNotification }),
        ...(dataParsed?.source && {
          source: dataParsed?.source,
        }),
      }));
    } else { navigate('/'); }
  }, [id]);
  const articleStored: Article | null = useSelector(selectArticle);
  useEffect(() => {
    if (articleStored) { setArticle(articleStored); }
  }, [articleStored]);
  const content = (
    <ContentWrapper>
      <h6 className="heading-popover">QuickShare to:</h6>
      {article && (
        <SocialShareIcons
          articleid={article.articleId || ''}
          title={article.title || ''}
          img={article.image || ''}
          domain={article.domain || ''}
          entity="article"
          alertId={article.alerts && article.alerts[0].alertId}
          url={article.url}
        />
      )}
    </ContentWrapper>
  );

  const addToFavorite = (idx: number) => {
    if (article) {
      const data = {
        articleId: idx,
        favoriteFlag: article.isFavorite ? 0 : 1,
      };
      dispatch(favouriteArticleActions.addToFavorite(data));
    }
  };

  const getEntities = () => {
    if (
      article?.articleExtraInfo
      && article?.articleExtraInfo.entities
      && article?.articleExtraInfo?.entities.length > 0) {
      return (
        <div className="entities-margin">
          <DrawerHeading heading="Entities mentioned" />
          <div className="d-flex entities_Block">
            {article?.articleExtraInfo.entities
              && article?.articleExtraInfo?.entities.length > 0
              && article?.articleExtraInfo?.entities.slice(0, 3).map((item) => (
                <EntityTile
                  engagements={item.engagement}
                  company={item.name}
                  margin="0px 10px 0px 0px"
                />
              ))}
          </div>
        </div>
      );
    }

    return null;
  };
  const getSkeletons = () => (
    <Row className="w-100">
      <Col span={12} xs={24} sm={24} md={12} className="gutter-row">
        <SkeletonCustom height="400px" width="98%" />
      </Col>
      <Col span={12} xs={24} sm={24} md={12} className="gutter-row">
        <ArticleDrawerSkeleton />
      </Col>
    </Row>
  );

  return (
    <StyleWrapper>
      {isActive() && <OneSignal />}

      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap" />
        <div className="right-side-wrap">
          {isActive() ? (
            <>
              <GlobalSearch iconMode={isTab} />
              <DrawerAlerts />
              <AccountPopOver />
            </>
          ) : (
            <GlobalButton
              title="Login"
              textColor="#ffffff"
              bgColor="#1EC252"
              borderRadius="25px"
              innerSpace="8px 20px"
              PaddingSm="4px 16px 6px 16px"
              height="36px"
              fontSize="18px"
              fontSizeSm="16px"
              buttonClassName="button-follow"
              onButtonClick={() => navigate('/')}
            />
          )}

        </div>
      </NavBarPrimary>

      <div className="d-flex justify-content-between content-area">
        {article && !_.isEmpty(article) ? (
          <>
            <div
              className="fancy-box col-custom"
            >
              <h2 className="article-title text-truncate-four-line">{article?.title}</h2>
              {article?.image
                ? (
                  <div ref={elementRef}>
                    <Image
                      className="article-image"
                      backgroundImage={setImageSize(
                        article?.image,
                        elementRef?.current?.clientWidth || 486,
                        elementRef?.current?.clientHeight || 440,
                        article?.articleId,
                      )}
                    />
                  </div>
                )
                : null}
              <span
                className={`article-details mt-c-20 ${showAll ? '' : 'text-truncate-four-line'}`}
              >
                {HTMLReactParser(article?.summary)}
              </span>
              <div className="article-metadata">
                <div className="source">
                  <span className="article-source">{article.domain}</span>
                  <span className="article-timestamp separator">{article.dateTimeStamp}</span>
                  <span className="article-company"><span className="separator">{article.companyName}</span></span>
                </div>
              </div>
              <div className={classNames('button-section d-flex justify-content-between', { justifyContentFlexEnd: !isActive() })}>
                {isActive()
                  ? (
                    <>
                      <div>
                        <Popover
                          placement="left"
                          content={content}
                          trigger="click"
                          getPopupContainer={(e: HTMLElement) => e}
                          className="popover-sharing"
                          arrow={false}
                        >
                          <span
                            className="tabs-item c-pointer"
                            aria-hidden="true"
                          >
                            <span>
                              Share
                            </span>
                            <span className="separator"> </span>
                            <ShareArticleStrokeIcon color={greyColor} />
                          </span>
                        </Popover>
                      </div>
                      <span
                        className="favorite-icon"
                        onClick={() => addToFavorite(article?.articleId)}
                        onKeyPress={() => addToFavorite(article?.articleId)}
                        tabIndex={0}
                        role="button"
                        aria-label="Favorite"
                      >
                        {!loading ? (
                          <FavoriteIcon color={`${article?.isFavorite ? favouriteArticleColor : whiteColor}`} />
                        )
                          : <SkeletonCustom width="25px" height="25px" diameter="10px" />}
                      </span>
                    </>
                  ) : null}

                <div>
                  {article?.summary !== '' ? (
                    <span
                      className="tabs-item c-pointer"
                      onClick={() => setShowAll(!showAll)}
                      onKeyPress={() => setShowAll(!showAll)}
                      tabIndex={0}
                      role="button"
                      aria-label={showAll ? 'Show Less' : 'Show More'}
                    >
                      {showAll ? 'Show Less' : 'Show More'}
                    </span>
                  ) : null}

                  <span
                    onClick={() => window.open(article?.url)}
                    onKeyPress={() => window.open(article?.url)}
                    tabIndex={0}
                    role="button"
                    aria-label="Visit Website"
                    className="tabs-item c-pointer"
                  >
                    Visit website
                  </span>
                </div>
              </div>
            </div>
            <div className="col-custom">
              {article?.articleExtraInfo && article?.articleExtraInfo.concepts
                && article?.articleExtraInfo.concepts.length > 0
                ? (
                  <div className="concepts-margin">
                    <DrawerHeading heading="Concepts mentioned" />
                    <DonutChart
                      bgColor="transparent"
                      data={formatConcepts(article?.articleExtraInfo.concepts ?? [])}
                      height={330}
                      width={530}
                      justifyContent
                    />
                  </div>
                )
                : null}
              {getEntities()}
            </div>
          </>
        ) : loading && <>{getSkeletons()}</>}
        {_.isEmpty(article) && !loading
          ? <NoDataFound title={NODATAFOUND} />
          : null}
      </div>
    </StyleWrapper>
  );
};

export default Articles;
